import React from 'react'

const NavArrow = ({ direction, onClick, style, className }) => {

  const arrowStyle = {
    ...style,
    fill: "#fff",
    fillRule: "evenodd",
    transform: direction === "right" ? "rotate(180deg)" : " ",
    transformOrigin: "left 12px",
    backgroundColor: "rgba(244, 244, 244, 0.3)",
    width: '50px',
    textAlign: 'center',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '49px',
    width: '70px'
  }

  return (
    <div style={arrowStyle} onClick={onClick} className={className} >
      <svg xmlns="http://www.w3.org/2000/svg" width="14.72" height="25.063" viewBox="0 0 14.72 25.063">
        <path className="cls-1" d="M6482.07,474.464l11.13-11.147a1.358,1.358,0,0,1,.97-0.4,1.335,1.335,0,0,1,.96.4l0.82,0.82a1.362,1.362,0,0,1,0,1.938l-9.34,9.361,9.35,9.37a1.375,1.375,0,0,1,0,1.939l-0.82.82a1.338,1.338,0,0,1-.96.4,1.361,1.361,0,0,1-.97-0.4l-11.14-11.157A1.381,1.381,0,0,1,6482.07,474.464Z" transform="translate(-6481.66 -462.906)" />
      </svg>
    </div>
  )
}


export default NavArrow
